import { TaxonomyPage, TaxonomySection } from '@zoopla/tracking';
import { Dispatch, SetStateAction } from 'react';
import { User } from '../../graphql.generated';

export type Segment = {
    page: TaxonomyPage;
    section: TaxonomySection;
    activity?: string | undefined;
};

export type ActionAfterAuth = {
    action: (user?: User) => void;
    eventLabel: string;
    segment?: Segment;
    pageType?: 'for-sale' | 'to-rent';
};

export type AuthModalMode = 'sign-in' | 'register' | 'situation-quick-access';

export type AuthModalProps = {
    heading?: string;
    initialMode?: AuthModalMode;
    isShowing: boolean;
    close: (user?: User, shouldSkipSituationStep?: boolean) => void;
    actionAfterAuth: ActionAfterAuth | null;
    resetActionAfterAuth?: () => void;
};

export interface SocialAuthProps extends AuthModalProps {
    onSocialAuth?: (user?: User) => void;
    shouldFetchUser?: boolean;
    setCurrentStep: Dispatch<SetStateAction<AuthModalStepKeys>>;
}

export type AuthModalTracking = {
    taxonomy: {
        registration_platform?: string;
        signed_in_status?: string;
    };
};

export type AuthModalStep = {
    title?: string;
    component: JSX.Element;
    trackingCategory?: string;
};

export enum AuthModalStepKeys {
    FORM_TABS = 'formTabs',
    PREFERENCES = 'preferences',
    SITUATION_QUICK_ACCESS = 'situationQuickAccess',
    YOUR_SITUATION = 'yourSituation',
    UPDATE_YOUR_SITUATION = 'updateYourSituation',
    UPDATE_YOUR_SITUATION_SELLER = 'updateYourSituationSeller'
}

export type AuthModalStepsConfig = {
    [key in AuthModalStepKeys]: AuthModalStep;
};
